module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av573-b923731b94072d6a1c43aeae73b1eaf5.jpg";